export { NMARSEmptyPageTemplate } from './nmarsEmptyPageTemplate';
